<template>
  <InputNumber
    v-model="currentValue"
    :precision="0"
    :min="1"
    style="width: 100%"
  />
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    currentValue: {
      get () {
        return this.value
      },
      set: _.debounce(function (newVal) {
        if (!_.isNumber(newVal) || newVal < 1) {
          return
        }
        this.$emit('input', newVal)
      }, 1000)
    }
  },

  watch: {
    value (val) {
      this.currentValue = val
    }
  }
}
</script>
